import { render } from "./IncomingCallLog.vue?vue&type=template&id=2e3f1dbc&scoped=true"
import script from "./IncomingCallLog.vue?vue&type=script&lang=js"
export * from "./IncomingCallLog.vue?vue&type=script&lang=js"

import "./IncomingCallLog.vue?vue&type=style&index=0&id=2e3f1dbc&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3f1dbc"]])

export default __exports__